<template>
  <v-card class="form-card list-profiles">
    <v-container class="wrapper pa-1">
      <v-row>
        <v-col cols="2" class="pl-0">
          <slot name="image"> </slot>
        </v-col>
        <v-col cols="9" class="pr-0 pl-1">
          <v-row>
            <v-col cols="12" class="py-0 ">
              <p
                class="sub-title-fields sub-title-fields--bold text-left text-uppercase"
              >
                {{ idtName }}
              </p>
            </v-col>
            <v-col cols="12" class="py-0">
              <p class="sub-title-fields text-left">
                {{ idtIdentifier }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
// import { mapGetters } from 'vuex';

// import IconLinkedIn from '@/assets/svg/icon-linkedin'
// import IconTwitter from '@/assets/svg/icon-twitter'
// import IconDiscord from '@/assets/svg/discordIcon'
// import IconReddit from '@/assets/svg/redditIcon'
// import IconGitHub from '@/assets/svg/icon-github'

export default {
  components: {
    // IconLinkedIn,
    // IconTwitter,
    // IconDiscord,
    // IconReddit,
    // IconGitHub,
    // WJazzIcon: () => {
    //   if (process.client) {
    //     return import('~/componentsClientOnly/WJazzIcon.vue')
    //   }
    // },
  },
  filters: {
    truncate(text = '', length, clamp) {
      clamp = clamp || '...';
      const content = text ? text.toString() : '';
      return content.length > length
        ? content.slice(0, length - 4) +
            clamp +
            content.slice(content.length - 4, content.length)
        : content;
    },
  },
  props: {
    idtImgSrc: {
      type: String,
      default: '',
    },
    idtName: {
      type: String,
      default: '',
    },
    idtIdentifier: {
      type: String,
      default: '',
    },
    // walletImg: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  computed: {
    // ...mapGetters({
    //   walletAddress: 'walletAddress',
    //   selectedSocialMedia: 'onlineIds/selectedSocialMedia',
    //   profile: 'onlineIds/profile',
    // }),
  },
};
</script>

<style lang="scss">
#metamask-logo-profile {
  max-height: 89px;
  max-width: 89px;

  border-radius: 50%;
  border: solid 2px transparent;
  margin: auto;
}
.v-card.form-card {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1) !important;
  max-width: 320px;
  .address-balloon {
    padding: 7px 7px 7px 8px;
    border-radius: 15px;
    background-color: #dbedef;
    max-width: 32%;
    margin: 0 auto;
    text-align: center;
    p {
      margin-bottom: 0;

      font-size: 13px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #009fb1;
    }
  }
  .light-grey-text {
    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.45;
    letter-spacing: normal;
    color: var(--charcoal-grey);
    margin-bottom: 0px;
  }
  &.list-profiles {
    padding-left: 34px;
    padding-right: 34px;
    .wrapper {
      &--border {
        border-top: solid 1px #eeeeee;
      }
      .sub-title-fields {
        font-size: 12px !important;
        font-weight: 600 !important;
        margin-bottom: 0;
      }
      .sub-title-fields--bold {
        font-size: 11px !important;
        font-weight: normal !important;
      }
      .MAIN-LINKS {
        font-size: 12px !important;
      }
      .v-icon {
        font-size: 18px;
      }
    }
  }
}
</style>
